import classNames from 'classnames';

import React, { forwardRef, ForwardRefExoticComponent, HTMLAttributes, RefAttributes } from 'react';

import styles from './divider.scss';

type DividerProps = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    dataTestId?: string;
  };

const COMPONENT_ID = 'modulor-divider';

export const Divider: ForwardRefExoticComponent<DividerProps> = forwardRef<
  HTMLDivElement,
  DividerProps
>(({ className, ...rest }, ref, dataTestId = COMPONENT_ID) => {
  const classes = classNames(styles.container, className);

  return (
    <div
      data-testid={dataTestId}
      data-id={dataTestId}
      data-component-name={COMPONENT_ID}
      className={classes}
      ref={ref}
      {...rest}
    />
  );
});

Divider.displayName = 'Divider';
